module.exports = __webpack_public_path__ + "static/media/illustrator.24edd28d.svg";